<!-- 跳转企业微信-企业列表 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
		<!-- 标题 -->
		<div class="page-title" style="position: sticky;left: 30px;z-index: 5;width: 300px;margin-bottom: 10px;">跳转企业微信-企业列表</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;width: 860px;">
			
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">状态</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择状态"
					@change="handleChangeA"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option value="1">开启</a-select-option>
					<a-select-option value="0">关闭</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			<a-button @click="addButton" type="primary">添加企业微信</a-button>
		</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell" style="cursor: default;" 
				:style="{'width':rableTitle[0].width + 'px'}" >
					{{rableTitle[0].title}}
				</div>
				<div class="table-th-cell" style="cursor: default;"
				:style="{'width':rableTitle[1].width + 'px'}" >
					{{rableTitle[1].title}}
				</div>
			</div>
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > 1" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
					<!-- ID -->
					<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
						{{item.id}}
					</div>
					<!-- 企业微信名称 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
						{{item.name}}
					</div>
				</div>
				
				<!-- Corp_id -->
				<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
					{{item.corp_id}}
				</div>
				<!-- Secret -->
				<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
					{{item.secret}}
				</div>
				<!-- Token -->
				<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
					{{item.token}}
				</div>
				<!-- Aes_key -->
				<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
					{{item.aes_key}}
				</div>
				<!-- Status -->
				<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
					{{item.status == 1?'是':'否'}}
				</div>
				<!-- 创建时间 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[7].width + 'px'}">
					{{item.created_at}}
				</div>
				<!-- 更新时间 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[8].width + 'px'}">
					{{item.updated_at}}
				</div>
				
				<!-- 操作 -->
				<div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[9].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					编辑
				</div>
				
			</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		<div :style="{'width': body_width + 'px',}" style="text-align: center;margin-top: 30px;position: sticky;left: 30px;z-index: 5;">
			<a-pagination v-model="r_page" :pageSize="20" :total="table_total" @change="paginationChange"  />
		</div>
	</div>
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  :title="drawer_title"
	  width="700px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">企业微信名称<span class="required-hint">*</span></div>
					
				<a-input v-model="x_name" placeholder="请输入" style="width: 450px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">corp_id<span class="required-hint">*</span></div>
					
				<a-input v-model="x_corp_id" placeholder="请输入" style="width: 450px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">secret<span class="required-hint">*</span></div>
					
				<a-input v-model="x_secret" placeholder="请输入" style="width: 450px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">token<span class="required-hint">*</span></div>
					
				<a-input v-model="x_token" placeholder="请输入" style="width: 450px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">aes_key<span class="required-hint">*</span></div>
					
				<a-input v-model="x_aes_key" placeholder="请输入" style="width: 450px;"  />
			</div>
			
			<div class="form-cell-box" style="height: 40px;">
				<div class="class-title">是否启用</div>
					
				<a-switch :checked="x_status" @change="switchChangeB" checked-children="打开" un-checked-children="关闭" />
			</div>
			
			
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
	
</div>
</template>

<script>
import { jumpQwList, jumpQwAdd, jumpQwEdit } from '@/request/api'
export default {
	name: 'jumpQwQy_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"企业微信名称", width:160, type:"name", },
				{title:"Corp_id", width:160, type:"corp_id", },
				{title:"Secret", width:200, type:"secret", },
				{title:"Token", width:200, type:"token", },
				{title:"Aes_key", width:200, type:"aes_key", },
				{title:"Status", width:100, type:"status", },
				{title:"创建时间", width:130, type:"created_at", },
				{title:"更新时间", width:130, type:"updated_at", },
				{title:"操作", width:100, type:"cz", },
				
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			
			search_button_loading: false,
			r_search:"",
			r_page: 1,
			table_total: 0,
			r_status: undefined, // 状态
			
			drawer_title: "新增", // 侧边栏标题
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			// 新增/编辑参数
			x_id: '', // id
			x_name: "", // 名称
			x_corp_id: "", // corp_id
			x_secret: "", // secret
			x_token: "", // token
			x_aes_key: "", // aes_key
			x_status: true, // 是否启用，true为启用
			
		}
	},
	mounted(){
		let that = this
		
		that.body_width = document.body.clientWidth - 100 // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		
		that.searchButton()
		
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		handleChangeA(e){
			console.log(e);
			this.r_status = e
		},
		// 搜索
		searchButton(){
			let that = this
			
			that.search_button_loading = true
			
			jumpQwList({
				page: that.r_page,
				status: that.r_status
				}).then(res=>{
				console.log("列表结果",res.data.data)
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					
					let data = res.data.data.data
					data.forEach((res,index)=>{
						res.status_checked = false
						res.status_loading = false // 变更状态的加载中状态
						if(res.status == 1){ // 1=开启 0=关闭
							res.status_checked = true
						}
					})
					that.tableShowData = data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 新增
		addButton(){
			let that = this
			that.drawer_title = "新增"
			that.visible = true
		},
		// 编辑
		editTable(index,item){
			let that = this
			console.log("item",item);
			that.drawer_title = "编辑"
			that.x_id = item.id
			that.x_name = item.name // 名称
			that.x_corp_id = item.corp_id // corp_id
			that.x_secret = item.secret // secret
			that.x_token = item.token // token
			that.x_aes_key = item.aes_key // aes_key
			
			if(item.status == 1){
				that.x_status = true
			}
			else {
				that.x_status = false
			}
			
			that.visible = true
		},
		// 查看权限
		showPermissions(){
			let that = this
			
		},
		// 侧边栏的新增/编辑
		addRequest(){
			let that = this
			console.log("contentTableData",that.contentTableData);
			if(!that.x_name){ // 名称
				// that.add_form_hint = "请填写 名称 ！！！"
				that.$message.warning('请填写 名称 ！！！');
			}
			else if(!that.x_corp_id){ // corp_id
				that.$message.warning('请填写 corp_id ！！！');
			}
			else if(!that.x_secret){ // secret
				that.$message.warning('请填写 secret ！！！');
			}
			else if(!that.x_token){ // token
				that.$message.warning('请填写 token ！！！');
			}
			else if(!that.x_aes_key){ // aes_key
				that.$message.warning('请填写 aes_key ！！！');
			}
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				
				let r_data = {
					id: that.x_id,
					name: that.x_name,
					corp_id: that.x_corp_id, // corp_id
					secret: that.x_secret, // secret
					token: that.x_token, // token
					aes_key: that.x_aes_key, // aes_key
				}
				if(that.x_status){
					r_data.status = 1 // 表示开启
				}
				else {
					r_data.status = 0 // 表示关闭
				}
				
				if(that.drawer_title === "新增"){
					jumpQwAdd(r_data).then(res=>{
						console.log("新增",res)
						that.add_button_loading = false
						
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.onCloseDrawer()
							that.$message.success('新增成功');
							that.searchButton()
						}
						else {
							if(res.data.code == 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
								return
							}
							that.$message.error(res.data.msg || "新增失败");
						}
					})
					.catch(err=>{
						console.log(err)
						that.$message.error("新增失败，可能是网络出现问题");
					})
				}
				else if(that.drawer_title === "编辑"){
					jumpQwEdit(r_data).then(res=>{
						console.log("编辑",res)
						that.add_button_loading = false
						if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
							that.onCloseDrawer()
							that.$message.success('编辑成功');
							that.searchButton()
						}
						else {
							if(res.data.code == 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
								return
							}
							that.$message.error(res.data.msg || "编辑失败");
						}
					})
					.catch(err=>{
						console.log(err)
						that.$message.error("编辑失败，可能是网络出现问题");
					})
				}
				
			}
			
		},
		// 侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
			this.visible = false
			this.x_id = ""
			this.x_name = "" // 名称
			
			this.x_corp_id = "" // corp_id
			this.x_secret = "" // secret
			this.x_token = "" // token
			this.x_aes_key = "" // aes_key
			this.x_status = true // 是否启用，true为启用
			
			this.add_form_hint = ""
		},
		
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
			
		},
		
		
		// 状态切换
		statusChange(e,item){
			let that = this
			console.log("状态切换",e,item);
			item.status_loading = true
			jumpQwEditStatus({
				id: item.id
			}).then(res=>{
				console.log("状态切换",res);
				item.status_loading = false
				
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					item.status_checked = e
					if(e){ // 这里的状态也要更新。1=开启 0=关闭
						item.status = 1
					}
					else {
						item.status = 0
					}
					that.$message.success('操作成功');
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		
		// 是否启用
		switchChangeB(e){
			console.log(e);
			this.x_status = e
		},
		// 添加
		addContent(){
			let obj = {
				key:"",
				value: "",
				limit: "",
				sort: ""
			}
			this.contentTableData.push(obj)
		},
		// 删除
		delContent(e,index){
			if(this.contentTableData.length > 0){ // 大于0是因为允许为空
				this.contentTableData.splice(index,1)
			}
		}
	}
}
</script>

<style scoped>
.form-cell-box {
	margin-bottom: 20px;
}

</style>